import { t } from 'i18next'
import React, { Component } from 'react'
import ButtonSimple from '~/Common-Objects/UI/Forms/ButtonSimple/ButtonSimple'
import Icons from '~/Common-Objects/UI/Icons/index'
import DragDropFunctions from '~/utils/TemplateEditor/dragDropFunctions'

export default class ComponentSelect extends Component {
    constructor(props) {
        super(props)
        this.change = this.change.bind(this)
    }

    change(theVal) {
        this.props.updateVal(this.props.path, theVal)
    }

    render() {
        var style = {}

        var thisOptions = this.props.options
        if (thisOptions && typeof thisOptions != 'object') {
            if (thisOptions.indexOf('OPTIONS') > 0) {
                thisOptions = DragDropFunctions.lookupVariables(thisOptions)
            }
        }

        if (this.props.localVariables) {
            const hasFullWidth = Object.values(this.props.localVariables).some(
                (lv) => lv.label?.toUpperCase() === 'WIDTH' && lv.value === '100%'
            )

            if (hasFullWidth) {
                return null
            }
        }

        return (
            <div className='dndEditorv2-dd_toolHolder' style={style}>
                <div className='dd_inputTool'>
                    <p className='txtInput_label'>{this.props.title}</p>
                    <div className='dndEditorv2-inputWrapper'>
                        <div className='dd_alignHolder dndEditorv2-alignHolder'>
                            {thisOptions.map((theOpt, index) => {
                                var theType = theOpt.value
                                var selected = ''
                                if (this.props.value === theType) {
                                    selected = ' selected'
                                }

                                var theTypeIcon = theType
                                switch (theTypeIcon) {
                                    case 'flex-start': {
                                        theTypeIcon = 'left'
                                        break
                                    }
                                    case 'flex-end': {
                                        theTypeIcon = 'right'
                                        break
                                    }
                                    default: {
                                        theTypeIcon = theTypeIcon
                                    }
                                }
                                theTypeIcon = theTypeIcon.charAt(0).toUpperCase() + theTypeIcon.slice(1)
                                return (
                                    <ButtonSimple
                                        key={theType + '_' + index}
                                        selected={this.props.value === theType}
                                        onClick={() => {
                                            this.change(theType)
                                        }}
                                        iconLeft={<Icons icon={'align' + theTypeIcon} color='currentColor' />}
                                    />
                                )
                            })}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
